module.exports = __webpack_public_path__ + "static/img/3_2.f3420fe4.jpg";